import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import PhproductEditForm from './PhproductEditForm';
import PhproductList from './PhproductList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import PhproductListView from './PhproductListView'


export default function PhproductDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.pharmaslice.phproductDashboard);
  const [ phproductId, setPhproductId] = React.useState('');
  const [reloadPhproductList, setReloadPhproductList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <PhproductEditForm 
            setReloadPhproductList={setReloadPhproductList}
            phproductId={phproductId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <PhproductListView 
                      setPhproductId = {setPhproductId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
